import { Heading, Surface, Text } from '@dx-ui/global-ui-prism';
import { Trans, useTranslation } from 'next-i18next';

export const JoinModalBenefitsSection = () => {
  const { t } = useTranslation('osc-join-modal-button');

  return (
    <section
      data-element-id="join-modal-benefits-section"
      className="bg-black/50 bg-[url('/modules/assets/img/brand/HH/honors-enrollment-form-background.png')] bg-cover bg-center bg-no-repeat p-6 bg-blend-darken sm:bg-surface sm:bg-none sm:p-0"
    >
      <div className="flex flex-col items-center gap-4">
        <Heading
          level={1}
          className="text-surface-interactive-contrast sm:text-surface-headline"
          size="lg"
        >
          {t('joinHiltonHonors')}
        </Heading>
        <div className="w-full max-w-xl overflow-hidden rounded-xl shadow-lg sm:border sm:border-t-0 sm:border-surface sm:shadow-none">
          <Surface type="inverse" className="py-2">
            <Heading level={2} size="sm" className="text-center">
              {t('benefitsSectionHeading')}
            </Heading>
          </Surface>
          <div className="flex flex-col gap-6 bg-surface p-4 px-5 text-start">
            <Text size="sm">
              <Trans
                ns="osc-join-modal-button"
                i18nKey="benefitsSectionPoint1"
                components={{ b: <strong className="font-semibold" /> }}
              />
            </Text>
            <Text size="sm">
              <Trans
                ns="osc-join-modal-button"
                i18nKey="benefitsSectionPoint2"
                components={{ b: <strong className="font-semibold" /> }}
              />
            </Text>
            <Text size="sm">
              <Trans
                ns="osc-join-modal-button"
                i18nKey="benefitsSectionPoint3"
                components={{ b: <strong className="font-semibold" /> }}
              />
            </Text>
          </div>
        </div>
      </div>
    </section>
  );
};
